// frontend/src/app/admin/AdminRouter.tsx
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import WorkflowBuilderPage from "./WorkflowBuilderPage";
import AdminLayout from "./AdminLayout";
import AdminGuard from "./AdminGuard";

// ----------------------
// Lazy Imports
// ----------------------

// Workflow Builder (flows + flow_runs engine)
const WorkflowBuilderPage = lazy(
  () => import("./workflow/WorkflowBuilderPage")
);

// Existing Admin pages
const ComposerPage = lazy(() => import("../../features/composer/ComposerPage"));
const TemplatesGallery = lazy(
  () => import("../../features/templates/TemplatesGallery")
) as any;
const DatasetsPage = lazy(() => import("./DatasetsPage"));
const DatasetManager = lazy(() => import("../../features/datasets/Manager"));
const EvalCreator = lazy(() => import("../../features/evals/Creator"));
const ResultsDashboard = lazy(
  () => import("../../features/evals/ResultsDashboard")
);
const ExperimentsPage = lazy(
  () => import("../../features/experiments/ExperimentsPage")
);
const ResultsBrowser = lazy(() => import("./ResultsBrowser"));
const EvalsPage = lazy(() => import("./EvalsPage"));
const FeedbackPage = lazy(() => import("./FeedbackPage"));

// Inline Components
const Overview = () => <div className="text-sm">Welcome to Admin.</div>;
const Runs = () => <div className="text-sm">Runs list coming soon.</div>;

// ----------------------
// MAIN ROUTER
// ----------------------

export default function AdminRouter() {
  const noopOnUse = () => {};

  return (
    <Suspense fallback={<div className="p-6">Loading admin…</div>}>
      <AdminGuard>
        <AdminLayout />

        <Routes>
          {/* Admin root redirect */}
          <Route
            path="/admin"
            element={<Navigate to="/admin/overview" replace />}
          />

          {/* Overview */}
          <Route path="/admin/overview" element={<Overview />} />

          {/* Legacy composer */}
          <Route path="/admin/composer" element={<ComposerPage />} />

          {/* NEW: Workflow Builder */}
          <Route path="/admin/workflow" element={<WorkflowBuilderPage />} />

          {/* Optional plural alias */}
          <Route path="/admin/workflows" element={<WorkflowBuilderPage />} />

          {/* Templates */}
          <Route
            path="/admin/templates"
            element={<TemplatesGallery onUse={noopOnUse} />}
          />

          {/* Datasets */}
          <Route path="/admin/datasets" element={<DatasetsPage />} />
          <Route
            path="/admin/datasets/manager"
            element={<DatasetManager />}
          />

          {/* Evals */}
          <Route path="/admin/evals/create" element={<EvalCreator />} />
          <Route
            path="/admin/evals/dashboard"
            element={<ResultsDashboard />}
          />
          <Route path="/admin/evals" element={<EvalsPage />} />

          {/* Experiments */}
          <Route path="/admin/experiments" element={<ExperimentsPage />} />

          {/* Runs */}
          <Route path="/admin/runs" element={<Runs />} />

          {/* Results */}
          <Route path="/admin/results" element={<ResultsBrowser />} />

          {/* Feedback */}
          <Route path="/admin/feedback" element={<FeedbackPage />} />

          {/* Catch-all */}
          <Route
            path="*"
            element={<Navigate to="/admin/overview" replace />}
          />
        </Routes>
      </AdminGuard>
    </Suspense>
  );
}